import Vue from 'vue'
import App from './App.vue'
import './utils/flexible.js'
import './style/index.scss'
import { VnToast, VnLoginToast, BsSetWebp, BsTrackExp, BsGetEnv, BsUtil, BsGetXcx, BsGetCid } from 'dida-web-common'
import router from './router.js'
import track from './utils/track'
import pageConf from './pageConf.js'
// import * as Sentry from '@dida-sentry/h5'
// import { BrowserTracing } from '@sentry/tracing'
// import packageInfo from '../package.json'
import packageInfo from '../package.json'

import getActiveData from './utils/getActiveData'
import _shareInit from './utils/share.js'
// import { ExposureDirective } from './utils/exp'

// 禁用浏览器的滚动位置恢复功能
function disableScrollRestoration() {
    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual'
    }
}
let zhiyuxiaochengxuhoutai = true
// 处理页面自动刷新
async function handleAutoRefresh() {
    const { isAli, isWx } = await BsGetXcx()
    zhiyuxiaochengxuhoutai = !(isAli || isWx) // 小程序默认是false
    const { cid } = await BsGetCid()
    if (cid && pageConf?.options?.basic?.autoRefresh) {
        document.addEventListener('visibilitychange', function() {
            // 未登录无需刷新页面
            if (document.visibilityState === 'visible' && zhiyuxiaochengxuhoutai) {
                (isAli || isWx) && (zhiyuxiaochengxuhoutai = false)
                location.reload()
            } else {
                (isAli || isWx) && (zhiyuxiaochengxuhoutai = true)
            }
        })
    }
}

function initSentry() {
    if (window.Sentry && pageConf?.options && pageConf.options.basic.sentry) {
        window.Sentry.init({
          Vue,
          release: packageInfo.name + '@' + packageInfo.version,
          environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
          dsn: pageConf.options.basic.sentry,
          integrations: [
            new window.BrowserTracing({
            //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
              tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
            })
          ],
          tracesSampleRate: 1.0
        })
      }
}

// 初始化 Vue 实例
async function initVue() {
    Vue.directive('exposure', BsTrackExp)
    const isSuWebp = await BsSetWebp.init(Vue)
    // eslint-disable-next-line prefer-const
    let { promotionCode, activityCode, url = '' } = pageConf.options.basic?.getDataMes || pageConf.options.basic
    promotionCode = BsUtil.queryString('promotionCode') || promotionCode
    activityCode = BsUtil.queryString('activityCode') || activityCode
    Vue.use(VnToast)
    const { prodectName } = pageConf.shareData
    Vue.config.productionTip = false
    Vue.prototype.$bus = new Vue({ data: () => ({ store: {}}) })
    Vue.prototype.$track = track(prodectName, url.indexOf('promotion/act') > -1 ? promotionCode : '', activityCode && Array.isArray(activityCode) ? activityCode[0] : activityCode)

    const vm = new Vue({
        data() {
            return {
                DATA: pageConf,
                emitList: {},
                closeLoading: false,
                productName: prodectName,
                shareData: pageConf?.shareData,
                isSuWebp,
                // 判断裂变活动客态和主态是否公用同一个页面
                liebianPageCommon: BsUtil.queryString('liebiancommon') || false,
                activeData: {
                    sceneCode: promotionCode,
                    activityCode: activityCode
                },
                updateInitData(acCode, acType, conditionList) {
                    getActiveData(vm, acCode, acType, conditionList)
                }
            }
        },
        router,
        mounted() {
            // this.$track?.addplugin([BsTrackExp, BsTrackwaitTime])
        },
        render: h => h(App)
    }).$mount('#appRender')

    // 回到H5页面自动刷新
    const autoRefresh = pageConf?.options?.basic?.autoReload
    // 登录功能
    Vue.prototype.$Login = function(cb) {
        VnLoginToast.vnLogin({
            autoRefresh: !!autoRefresh,
            success: async(user) => {
                cb && cb(user)
                vm.$track.addStat('h5_will_enter_page')
                // const { isAli, isWx } = await BsGetXcx()

                // // 如果是小程序或者支付宝小程序，且配置了自动刷新，则不需要手动接口
                // if ((isAli || isWx) && pageConf?.options?.basic?.autoRefresh) {
                //    return
                // }
                vm.$bus.$emit('logined', { ...user })
                getActiveData(vm)
            }
        })
    }
    // 打开H5自动登陆
    const autoLogin = pageConf?.options?.basic?.autoLogin
    if (autoLogin === false) {
        VnLoginToast.vnLogin({
            autoRefresh: !!autoRefresh,
            success: () => {
                getActiveData(vm)
            }
        })
    } else {
        getActiveData(vm)
    }

    return vm
}

// 主初始化函数
async function init() {
    disableScrollRestoration()
    handleAutoRefresh()
    await initVue()
    if (pageConf && pageConf.shareData) {
        _shareInit(pageConf.shareData)
    }
    initSentry()
}

init()
